import { createSlice } from '@reduxjs/toolkit'

// const STORED_COMPANY = storedCompany => {
//   const settings = {};
//
//   Object.entries(storedCompany).forEach(([k, v]) => {
//     const ls_value = localStorage.getItem(`app.company.${k}`);
//
//     if (!ls_value) {
//       localStorage.setItem(`app.company.${k}`, v.toString());
//       settings[k] = v;
//     } else {
//       settings[k] = ls_value === 'true';
//     }
//   });
//
//   return settings;
// };

const initialState = {
  selected: -1,
}

const companySlice = createSlice({
  name: '_company',
  initialState,
  reducers: {
    set_setting: (state, action) => {
      const { setting, value } = action.payload
      localStorage.setItem(`app.company.${setting}`, value)
      state[setting] = value
    },
    toogle_setting: (state, action) => {
      const setting = action.payload
      const value = !state[setting]
      localStorage.setItem(`app.company.${setting}`, value)
      state[setting] = value
    },
  },
})

export const { set_setting, toogle_setting } = companySlice.actions

export default companySlice
